const multiColumnATC = () => {
    document.querySelectorAll('.column__btn .btn__atc').forEach(button => {
        button.addEventListener('click', function () {
            const url = this.getAttribute('data-url');
            const [path, query] = url.split('?');
            const [variantData] = path.split('/cart/').slice(1);
            const [variantId, quantity] = variantData.split(':');
            const params = new URLSearchParams(query);
            const discount = params.get('discount');
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: parseInt(quantity, 10),
                }),
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to add product to cart');
                }
                return response.json();
            })
            .then(data => {
                console.log(data);
            })
            .catch(error => {
                console.error(error);
            });
        });
    });
}
if(Shopify.designMode) {
    document.addEventListener("shopify:section:load", function(event) {
        multiColumnATC();
    });
};
document.addEventListener("DOMContentLoaded", function () {
    if(document.querySelector('.section-columns')) {
        multiColumnATC();
    }
});

if(document.querySelector("#all-natural-skincare-starter-set")) {
    setTimeout(() => {
        // Code to be executed after 2 seconds
        document.querySelector("#all-natural-skincare-starter-set .skincare-starter-set-4oz").remove();
    }, 2000);
}

const varaintChange = () => {
    const container = document.querySelector('.template-product .index-product');
    const newPrice = document.querySelector('.template-product .index-product .new-sale-price');
    const oldPrice = document.querySelector('.template-product .index-product .old-price');
    const discount = newPrice.getAttribute('data-discount');

    container.addEventListener('theme:variant:change', async (event) => {
        const variantData = JSON.parse(container.querySelector('[data-product-json]').textContent)
        const selectedVariantId = container.querySelector('[name="id"]').value;
        const selectVaraintObj = Object.values(variantData.variants).filter(
            (obj) => obj.id == selectedVariantId
        )

        const basePrice = selectVaraintObj[0].price / 100;

        if (discount === '10') {
            newPrice.innerText = `$${(basePrice * 0.9).toFixed(2)}`;
        } else if (discount === '20') {
            newPrice.innerText = `$${(basePrice * 0.8).toFixed(2)}`;
        } else if (discount === '30') {
            newPrice.innerText = `$${(basePrice * 0.7).toFixed(2)}`;
        } else {
            newPrice.innerText = `$${basePrice.toFixed(2)}`;
        }

        oldPrice.innerText = `$${basePrice.toFixed(2)}`;
    })
}
varaintChange();